/**
 * 批量设置套餐 模态框
 * Created by TzuHsing on 2020-10-13
 */

import React from 'react'
import { Modal, Row, Col, message, Table, Button } from 'antd'
// import AddPackage from './AddPackage'
import NewPackageModal from './newPackageModal'
import { DISABLE, ENABLE } from '../constants'
import { changeToDecimal } from '../../../util'
export default class extends React.Component {
  state = {
    allowPackage: [],
    disallowPackage: [],
    isLoading: false,
    typingPackageName: '',
    typingPackagePrice: '',
    typingPackageTime: '',
    isBindAfterAdd: false,
    purchaseStartTime: '00:00:00', // 新增限时开始时间
    purchaseEndTime: '00:00:00', // 新增限时结束时间
    purchaseWeekday: ['1', '1', '1', '1', '1', '1', '1'], // 新增选择日期
    isPurchaseLimitEnabled: false,
    allPackageInfo: {},
    tables: [],
    isDel: false,

    visible: false,
  }

  componentDidMount() {
    this.updatePackage()
  }

  //找到所有球台共同启用的套餐
  updatePackage = () => {
    this.setState({ isLoading: true }, async () => {
      await this.props.fetchAllPackage()
      const { allPackage, tables } = this.props
      let allPackageInfo = {}
      allPackage &&
        allPackage.map((item) => {
          allPackageInfo[item.id] = false
        }) //all Package default is false
      let data
      if (this.state.isDel) {
        data = this.state.tables //删除后的值
      } else {
        data = tables //初值
      }
      const tableIdArr = data.map((item) => +item.table_id) //获取当前编辑中的球台id字符串数组
      const packageIdList = this.props.allPackage.map((item) => item.id) //获取套餐的id列表
      this.props.fetchCurrentTableByPackage(
        {
          prepaid_ids: packageIdList,
        },
        (isSuccess, res) => {
          if (isSuccess) {
            //获取每个套餐绑定了的球台的对象
            let packageInfo = {}
            for (let item of res.data) {
              if (
                packageInfo[item.prepaidId] &&
                Array.isArray(packageInfo[item.prepaidId])
              ) {
                packageInfo[item.prepaidId].push(+item.tableId)
              } else {
                packageInfo[item.prepaidId] = [+item.tableId]
              }
            }
            for (let packageId of Object.keys(packageInfo)) {
              //循环有启用过球台的套餐id
              let isInclude = false
              for (let i of tableIdArr) {
                isInclude = packageInfo[+packageId].includes(+i)
                allPackageInfo[+packageId] = isInclude
                if (!isInclude) break
              }
              allPackageInfo[+packageId] = isInclude
            }
            this.setState({ allPackageInfo, isLoading: false })
          } else {
            this.setState({ isLoading: false })
          }
        }
      )
    })
  }

  handleChangePackage(id) {
    const newAllPackageList = Object.assign({}, this.state.allPackageInfo)
    newAllPackageList[id] = !newAllPackageList[id]
    this.setState({ allPackageInfo: newAllPackageList })
  }

  resetState() {
    this.setState({
      typingPackageName: '',
      typingPackagePrice: '',
      typingPackageTime: '',
      isLoading: false,
    })
  }

  //新建套餐 完成
  handleCreatePackage = async () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        const {
          typingPackageName,
          typingPackagePrice,
          typingPackageTime,
          isBindAfterAdd,
          purchaseStartTime,
          purchaseEndTime,
          purchaseWeekday,
          isPurchaseLimitEnabled,
        } = this.state
        const isPromiseChange =
          /^\d+(\.\d{1,2})?$/.test(typingPackagePrice) &&
          /^\d+(\.\d{1,2})?$/.test(typingPackageTime)
        if (
          typingPackageName &&
          typingPackagePrice !== undefined &&
          !!typingPackageTime !== undefined &&
          isPromiseChange
        ) {
          const club = sessionStorage.getItem('club_id')
          let data = {
            club_id: +club,
            name: typingPackageName,
            amount: +typingPackagePrice * 100,
            duration: +typingPackageTime * 60,
            isPurchaseLimitEnabled: isPurchaseLimitEnabled ? 1 : 0,
          }
          if (isPurchaseLimitEnabled) {
            data = {
              ...data,
              purchaseStartTime,
              purchaseEndTime,
              purchaseWeekday: parseInt(purchaseWeekday.reverse().join(''), 2),
            }
          }
          this.props.fetchAddPackage(data, async (isSuccess, res) => {
            if (isSuccess) {
              //哪里改变了
              if (isBindAfterAdd) {
                this.resetState()
                await this.props.fetchAllPackage()
                this.handleChangePackage(res.data[0].id)
              } else {
                await this.updatePackage()
                this.resetState()
              }
            } else {
              this.setState({ isLoading: false }, () =>
                message.error(res ? res.detail : '服务暂不可用')
              )
            }
          })
        } else {
          this.setState({ isLoading: false }, () => message.error('请输入完整'))
        }
      }
    )
  }

  returnCurrentColumns(isAllow) {
    return [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
        width: 80,
        defaultSortOrder: 'descend',
        sorter: (a, b) => (+a.id > +b.id ? 1 : -1),
      },
      {
        title: '套餐名',
        dataIndex: 'name',
        key: 'name',
        width: 140,
      },
      {
        title: '价格(元)',
        dataIndex: 'amount',
        key: 'amount',
        width: 90,
        render: (text, record) => <span>{record.amount / 100}</span>,
      },
      {
        title: '时长(分钟)',
        dataIndex: 'duration',
        key: 'duration',
        width: 100,
        render: (text, record) => (
          <span>{+changeToDecimal(+record.duration / 60)}</span>
        ),
      },
      {
        title: '限时购买使用',
        dataIndex: 'purchaseWeekday',
        key: 'purchaseWeekday',
        render: (text, record) => {
          const showText = this.props.timeLimitText(record)
          return <span>{showText}</span>
        },
      },
      {
        title: '操作',
        key: 'action',
        width: 80,
        render: (text, record) => (
          <div onClick={() => this.handleChangePackage(record.id)}>
            {isAllow ? (
              <Button type="primary" danger>
                关闭
              </Button>
            ) : (
              <Button type="primary">启用</Button>
            )}
          </div>
        ),
      },
    ]
  }

  setTypingInfo = (typingAttr, value) => {
    this.setState(() => ({ [typingAttr]: value }))
  }

  setTypingSwitch = (typingAttr, value) => {
    this.setState((preState) => ({ [typingAttr]: !preState[typingAttr] }))
  }

  returnCurrentDataSource(isAllow) {
    const { allPackageInfo } = this.state
    const { allPackage } = this.props
    if (isAllow) {
      return allPackage.filter((item) => {
        return allPackageInfo[item.id]
      })
    } else {
      return allPackage.filter((item) => {
        return !allPackageInfo[item.id]
      })
    }
  }

  //删除
  onDelete = (id, isDel) => {
    console.log(id, isDel)
    const { tables } = this.props
    let data
    if (this.state.isDel) {
      if (this.state.tables.length == 1) {
        return
      }
      data = this.state.tables.filter((item) => item.table_id !== id)
    } else {
      if (tables.length == 1) {
        return
      }
      data = tables.filter((item) => item.table_id !== id)
    }
    this.setState({ tables: data, isDel: isDel })
  }

  handleOK = () => {
    const isConfirm = window.confirm('此操作将会对球台套餐进行覆盖,确定继续吗?')
    if (isConfirm) {
      this.setState({ isLoading: true }, async () => {
        const { club, tables } = this.props
        const { allPackageInfo } = this.state
        let allowPackageList = []
        let disAllowPackageList = []
        for (let i in allPackageInfo) {
          if (allPackageInfo[i]) {
            allowPackageList.push(i)
          } else {
            disAllowPackageList.push(i)
          }
        }
        let data
        if (this.state.isDel) {
          data = this.state.tables //删除后的值
        } else {
          data = tables //初值
        }
        const tableIdArr = data.map((item) => +item.table_id) //获取当前编辑中的球台id字符串数组
        if (allowPackageList.length > 0) {
          this.props.fetchBindPackage(
            {
              prepaid_ids: allowPackageList,
              table_ids: tableIdArr,
              is_enabled: ENABLE,
            },
            (isSuccess, res) => {
              if (isSuccess) {
                this.props.handleOk()
              } else {
                message.error(
                  '保存失败,可能有球台正在使用该套餐开台，请先结账后再进行删除'
                )
              }
            }
          )
        } else {
          this.props.fetchBindPackage(
            {
              prepaid_ids: disAllowPackageList,
              table_ids: tableIdArr,
              is_enabled: DISABLE,
            },
            (isSuccess, res) => {
              if (isSuccess) {
                this.props.handleOk()
              } else {
                message.error(
                  '保存失败,可能有球台正在使用该套餐开台，请先结账后再进行删除'
                )
              }
            }
          )
        }
      })
    }
  }

  // 关闭新建套餐模态窗
  handleCancel = () => {
    this.setState({
      visible: false,
    })
  }

  render() {
    const { isShowBatchEditModal, tables } = this.props
    const columns1 = this.returnCurrentColumns(true)
    const columns2 = this.returnCurrentColumns(false)
    const dataSource1 = this.returnCurrentDataSource(true)
    const dataSource2 = this.returnCurrentDataSource(false)
    const { isLoading } = this.state
    let data
    if (this.state.isDel) {
      data = this.state.tables //删除后的值
    } else {
      data = tables //初值
    }
    return (
      <div>
        <Modal
          title="批量设置套餐"
          visible={isShowBatchEditModal}
          okText="保存设置"
          className={'batchEditPackage'}
          onOk={this.handleOK}
          onCancel={this.props.handleCancel}
          confirmLoading={isLoading}
          width="90vw"
        >
          <div className="gutter-example" style={{ marginBottom: '10px' }}>
            <Row gutter={16}>
              {data &&
                data.map((item, idx) => {
                  return (
                    <Col
                      onClick={() => this.onDelete(item.table_id, true)}
                      className="gutter-row"
                      span={4}
                      key={idx}
                    >
                      <div className="gutter-box">{`${idx + 1}.${
                        item.name
                      }`}</div>
                      <div className="gutter-delete">×</div>
                    </Col>
                  )
                })}
            </Row>
          </div>
          {/* <AddPackage
            {...this.state}
            setTypingInfo={(typingAttr, value) =>
              this.setTypingInfo(typingAttr, value)
            }
            setTypingSwitch={(typingAttr, value) =>
              this.setTypingSwitch(typingAttr, value)
            }
            handleCreatePackage={() => this.handleCreatePackage()}
          /> */}
          <div>
            <Button
              type="primary"
              onClick={() => {
                this.setState({
                  visible: true,
                })
              }}
            >
              新建套餐
            </Button>
          </div>
          <div className="handleList-box">
            <div className="enablePackage">
              <h3>启用中套餐</h3>
              <Table
                rowKey="id"
                bordered
                columns={columns1}
                loading={isLoading}
                dataSource={dataSource1}
                pagination={{ pageSize: 9 }}
              />
            </div>
            <div className="unablePackage">
              <h3>未启用套餐</h3>
              <Table
                rowKey="id"
                bordered
                columns={columns2}
                loading={isLoading}
                dataSource={dataSource2}
                pagination={{ pageSize: 9 }}
              />
            </div>
          </div>
        </Modal>

        {this.state.visible && (
          <NewPackageModal
            visible={this.state.visible}
            handleCancelPackage={this.handleCancel}
            updatePackageView={this.updatePackage}
          ></NewPackageModal>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/batchEditPackage.js